@if (isInitialized) {
  <oe-flat-widget [modalComponent]="modalComponent" [title]="component.alias"
    [icon]="{color: 'normal', name:'flame'}">
    <oe-flat-widget-line [name]="'GENERAL.STATUS' | translate" [value]="status | translate"
      [converter]="CONVERT_POWER_2_HEAT_STATE">
    </oe-flat-widget-line>
    <oe-flat-widget-line [name]="'EDGE.INDEX.WIDGETS.HEAT.HEATING_OUTPUT' | translate"
      [channelAddress]="component.id + '/ActivePower'" [converter]="CONVERT_WATT_TO_KILOWATT">
    </oe-flat-widget-line>
    <oe-flat-widget-line [name]="'EDGE.INDEX.WIDGETS.HEAT.TEMPERATURE' | translate"
      [channelAddress]="component.id + '/Temperature'"
      [converter]="Converter.DEZIDEGREE_CELSIUS_TO_DEGREE_CELSIUS">
    </oe-flat-widget-line>
    @if (component.factoryId === "Heat.Askoma") {
      <oe-flat-widget-line [name]="'HEAT.HOME.CHOSEN_MODE' | translate"
        [channelAddress]="component.id + '/_PropertyMode'"
        [converter]="CONVERT_TO_MODE_LABEL">
      </oe-flat-widget-line>
    }
  </oe-flat-widget>
}
